import { useMediaQuery } from "@mui/material";
import { StatsLogo, StatsSmLogo } from "../../constant/ImagesS3";
import "./AboutUs.css";
function Stats() {
  const isSmallScreen = useMediaQuery("(max-width: 768px)");

  return (
    <div className="stats-container-box">
      <div className="stats-container">
        <div className="stats-logo-box">
          <img
            src={isSmallScreen ? StatsSmLogo : StatsLogo}
            alt="logo"
            className="stats-logo-img"
          />
          <div className="stats-logo-name">
            Bataiyo <br />
            <span className="stats-logo-desc">at glance</span>
          </div>
        </div>
        <div className="stats-num-box">
          <div>
            <div className="stats-num-head">0</div>
            <div className="stats-num-sub-head">Commission Charged</div>
          </div>
          <div className="stats-num-inner-box">
            <div className="stats-num-head">2021</div>
            <div className="stats-num-sub-head">Year Founded</div>
          </div>
          <div>
            <div className="stats-num-head">2025</div>
            <div className="stats-num-sub-head">App Launched</div>
          </div>
          <div>
            <div className="stats-num-head">240+</div>
            <div className="stats-num-sub-head">Services</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Stats;
